import img1 from '/static/img/aboutUs/commitment/img1.png'
import img2 from '/static/img/aboutUs/commitment/img2.png'
const commitmentInfo = {
    resourcesTitle:'Rich In Tourism Resources',
    resourcesDesc:'We offer visitors the most comprehensive range of travel resources in China and can help you personalize your travel preferences. Whether it\'s in terms of resources, services or problem solving, we can meet your needs.',
    resourcesImg:img1,
    servicesTitle:'Professional Services',
    servicesImg:img2,
    servicesDescList:[
        {
            id:1,
            desc:'Having the most professional travel planner in China'
        },
        {
            id:2,
            desc:'Leaders of tours with many years of experience'
        },
        {
            id:3,
            desc:'We offer our clients the most unique and beautiful group tour routes.'
        },
        {
            id:4,
            desc:'The highest level of luxury and customization on group tours, including support for upgrading to private jets or top-of-the-line sports cars, etc.'
        },
        {
            id:5,
            desc:'Health insurance for emergencies in the travel environment.'
        }
    ]
}
export default {
    commitmentInfo
}